var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessCircularBanner = function SvgSuccessCircularBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398,
    height: 345,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "success-circular-banner_svg__b",
    width: 397,
    height: 390,
    x: 9,
    y: -136,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#success-circular-banner_svg__a)",
    d: "M9.174-135.666h396.07v389.402H9.174z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#success-circular-banner_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "success-circular-banner_svg__d",
    width: 397,
    height: 391,
    x: 7,
    y: -136,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#success-circular-banner_svg__c)",
    d: "M7.229-135.092h396.07V254.31H7.229z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.334,
    mask: "url(#success-circular-banner_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.609,
    r: 192.034,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.608,
    r: 174.697,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.93,
    cy: 57.609,
    r: 157.361,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.93,
    cy: 57.608,
    r: 140.025,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.609,
    r: 122.688,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.608,
    r: 105.352,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.608,
    r: 86.682,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.928,
    cy: 57.608,
    r: 69.346,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.93,
    cy: 57.608,
    r: 52.009,
    fill: "url(#success-circular-banner_svg__e)",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.609,
    r: 36.006,
    fill: "#2B2B2B",
    stroke: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.929,
    cy: 57.609,
    r: 29.338,
    fill: "#424242",
    stroke: "#5F5F5F"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.797,
    d: "m190.951 59.01 4.935 5.483 13.71-14.258"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-circular-banner_svg__a",
    x1: 207.209,
    x2: 207.209,
    y1: -110.995,
    y2: 182.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-circular-banner_svg__e",
    x1: 199.93,
    x2: 199.93,
    y1: 4.933,
    y2: 110.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "success-circular-banner_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 194.701 -198.035 0 205.263 59.609)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
export default SvgSuccessCircularBanner;